/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

export enum BatteryPassCategoryEnum {
  ev = 'ev',
  lmt = 'lmt',
  stationary = 'stationary',
  industrial = 'industrial',
  industrialWithoutBms = 'industrialWithoutBms',
}
